import React, { useState, useEffect } from "react";
import "./common.css";
import API_URL from "../common/Apiurl";
import { useParams  } from "react-router-dom"
import SuccessMessage from "../common/Message";
import Loader from "react-js-loader";

function AddDocuments() {
  // Add Document
  const apiUrl = API_URL;
  const subcatId = useParams();
  const [industry, setindustry] = useState("");
  const [successMessages, setSuccessMessages] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [users, setUsers] = useState([]);
  const [query, setQuery] = useState('');
  const [driving_licence, setDrivingLicence] = useState('');
  const [address, setAddress] = useState('');

  const [selectedValue, setSelectedValue] = useState(0);
  
  console.log(subcatId.user_id)

  const getComments = async () => {
    try {
      let post_data = {}
      if (subcatId.user_id) { 
        post_data = {
          user_id : subcatId.user_id
        }
        setSelectedValue(subcatId.user_id)
      }
      else {
        post_data = {
          user_id : selectedValue
        }
      }
      setIsloading(true);
      const res = await fetch(`${apiUrl}/admin/get-users-not-uploaded`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(post_data)
      });
      const data = await res.json();
      if (data.status !== 200) {
        throw new Error("Data not found");
      }
        setUsers(data.data);
        setIsloading(false);
        setDrivingLicence(data.driving_licence)
        setAddress(data.address)
    } catch (error) {
      console.error("Error ", error);
    }
  };
  useEffect(() => {
    getComments();
  }, []);
  
  const filteredUsers = users.filter(
    user =>
      user.name?.includes(query.toLowerCase()) ||
      user.email?.includes(query.toLowerCase()) || 
      user.mobile_number?.includes(query.toLowerCase())
  );

  const handleSuccessMessageFadeOut = () => {
    setSuccessMessages((prevMessages) => prevMessages.slice(1));
  };
  const handleDivingLicenseChange = async (e) => {
    // e.preventDefault();
    console.log(e.target.files)
    // setImage1(e.target.files[0]);
    // console.log(image1)
    const formData = new FormData();
    formData.append('type', 'driving_licence');
    formData.append('driving_licence', e.target.files[0]);
    formData.append('user_id', selectedValue);
    
    const employerresult = await fetch(`${apiUrl}/admin/uploadDocumentsForAdmin`, {
      method: "POST",
      body: formData,
      // headers: { 'Content-Type': 'multipart/form-data' }

    });
    const updatedData = await employerresult.json();
    if (updatedData.status === 200) {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    } else {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    }
    // getComments();
  };
  const handleAddressChange = async (e) => {
    // setImage2(e.target.files[0]);
    // e.preventDefault();
    const formData = new FormData();
    formData.append('type', 'address');
    formData.append('address', e.target.files[0]);
    formData.append('user_id', selectedValue);

    const employerresult = await fetch(`${apiUrl}/admin/uploadDocumentsForAdmin`, {
      method: "POST",
      body: formData,
      // headers: { 'Content-Type': 'multipart/form-data' }
    });
    const updatedData = await employerresult.json();
    if (updatedData.status === 200) {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    } else {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    }
    // getComments();
  };
  const clicktoaddindustry = () => {
    getComments()
  }
  const changeDocumentStatus = async (updatedemp) => {
    const employerresult = await fetch(`${apiUrl}/admin/changeDocumentStatus`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(updatedemp),
    });
    const updatedData = await employerresult.json();
    if (updatedData.status === 200) {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    } else {
      const newSuccessMessage = updatedData.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
    }
    getComments();
  };
  // console.log(image)
  // Add Document
  return (
    <div className="width90">
      <h2 className="pageTitle">Add Document</h2>
      {isLoading ? (
        <Loader type="spinner-cub" title={"loading....."} size={100} />
      ) : (
        <div className="commonCntr">
          <div className="form-horizontal">
          {selectedValue === 0 ? 
            <div className="form-group">
              <label
                className="control-label col-sm-2 label"
                htmlFor="industryname"
              >
                Select User id :
              </label>
              <div className="col-sm-9">
                <select class="form-select col-sm-9 selectBox" onChange={(e)=>setSelectedValue(e.target.value)}>
                    <option value=''>Select Users</option>
                    {filteredUsers.map((item , index) => {
                        return(<option value={item.id}>{item.name}- {item.email} - {item.mobile_number}</option>
                    )})}
                </select>
              </div>
            </div> :<></> }
            {selectedValue === 0 ? <></>: 
            <div>
              {!driving_licence ? 
              <div className="form-group">
                <label
                  className="control-label col-sm-2 label"
                  htmlFor="industryname"
                >
                  Driving Licence:
                </label>
                <div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleDivingLicenseChange}
                  />
                </div>
              </div> :<></>}
              {!address ? 
              <div className="form-group">
                <label
                  className="control-label col-sm-2 label"
                  htmlFor="industryname"
                >
                  Address Proof:
                </label>
                <div>
                  <div>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleAddressChange}
                  />
                </div>
                </div>
              </div> :<></>}
            </div>}
            {
              driving_licence ? 
              <div className="form-group mt-4">
                  <label className="control-label col-sm-3 label">
                    Document Approval Status
                  </label>
                  <input
                    type="checkbox"
                    id="driving_licence"
                    name="driving_licence"
                    checked={driving_licence.status}
                    onChange={() =>
                      changeDocumentStatus({
                        id: driving_licence.id,
                        status: !driving_licence.status,
                      })
                    }
                  />{" "}
                  <label className="control-label col-sm-2 label">
                    {driving_licence.type === "driving_licence"
                      ? "Driving Licence"
                      : "Address Documents"}
                  </label>
                  <div className="col-sm-4  mt-1">
                  <iframe
                      src={driving_licence.image}
                      class="img-fluid small-image"
                      alt="No Document uploaded yet"
                    ></iframe>
                    <a target="_blank" href={driving_licence.image}>Preview</a>
                  </div>
                </div> : <></>
            }
            {
              address ? 
              <div className="form-group mt-4">
                  <label className="control-label col-sm-3 label">
                    Document Approval Status
                  </label>
                  <input
                    type="checkbox"
                    id="address"
                    name="address"
                    checked={address.status}
                    onChange={() =>
                      changeDocumentStatus({
                        id: address.id,
                        status: !address.status,
                      })
                    }
                  />{" "}
                  <label className="control-label col-sm-2 label">
                      Address Documents
                  </label>
                  <div className="col-sm-4  mt-1">
                  <iframe
                      src={address.image}
                      class="img-fluid small-image"
                      alt="No Document uploaded yet"
                    ></iframe>
                    <a target="_blank" href={address.image}>Preview</a>
                  </div>
                </div> : <></>
            }
            <div>
              <button
                className="btn btn-default submitBtn"
                onClick={clicktoaddindustry}
              >
                Preview
              </button>
            </div>
          </div>
          {successMessages.map((message, index) => (
            <SuccessMessage
              key={index}
              message={message}
              onFadeOut={handleSuccessMessageFadeOut}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default AddDocuments;
